import { Component, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SvgInlineDirective } from '../../../shared/directives/svg/svg-inline.directive';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    SvgInlineDirective,
    NgbDropdownModule,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  currentLang: 'ar' | 'en' = 'ar';
  isRtl: boolean = true;
  baseUrl = environment.apiUrl;
  constructor(@Inject(DOCUMENT) private document: Document,
  private router:Router,
private languageService: LanguageService) {}

  ngOnInit(): void {
  }

    toggleLanguage(): void {
    const newLang = this.languageService.getLanguage() === 'ar' ? 'en' : 'ar';
    this.languageService.setLanguage(newLang);
    window.location.reload();
  }

  goToHome() {
    this.router.navigateByUrl("/home");
  }
}
